<template>
  <div class="referred">
    <v-card-text>
      <div class="req-list">
        <div class="req-card"  style="padding: 2px"  v-for="item in request_items"
             :key="item.Id">
          <div>
            <div class="row ">
              <div class="col-6">
                <div
                  class="req-name"
                  v-text="item.ProductName"
                ></div>
              </div>
              <div class="col-3">
                <div
                    class="req-name"
                  v-text="item.Qty+' عدد '"
                ></div>

              </div>
              <div class="col-3">
                <div
                  class="req-name"
                  v-text="item.SourceBranchName"
                ></div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <div class="req-attachment">
        <div class="card">
          <v-row class="">
            <v-col cols="6">{{ $t('add_file') }}</v-col>
            <v-col class="text-end" style="padding: 0px" cols="6">
              <v-btn v-if="files.length==0"
                color="primary"
                dark
                @click="select_file()"
                class="ma-2"
              >
                <v-icon
                  dark
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </v-col>
            <v-row>
              <input id="fileUpload" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.gif" type="file" hidden
                     v-on:change="input_file_changed">
              <v-row style="margin-bottom: 35px; margin-top: 35px;">
                <v-col cols="4"
                       v-for="(item, i) in files"
                       :key="i"
                >
                  <v-icon v-on:click="delete_file(i)" style="color: crimson">
                    mdi-close
                  </v-icon>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <img style="height: 100px!important;width: 100px!important;" loading="lazy" :src="item.file" width="100px"
                       height="100px"/>

                </v-col>
              </v-row>
            </v-row>

          </v-row>
        </div>
      </div>

      <v-btn color="primary m-0" class="btn-end" v-on:click="save()">
        {{$t('sendFiles')}}
      </v-btn>
      <infinite-loading @infinite="infiniteHandler" v-if="show_loading">
        <div slot="no-more">{{ $t('no_records') }}</div>
      </infinite-loading>

    </v-card-text>

  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import {bus} from '../../main'
  import { longClickDirective } from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";

  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        files: [],
        product_info_dialog:false,
        selected_product_info:{},
        list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click:false,
        category_items: [],
        request_statuses: [],

        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
      Treeselect
    },
    watch: {
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      }
    },
    mounted() {
      this.get_pre_requests()
      this.get_device_status();
    },

    methods: {
      get_device_status () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetStatusSetting', send_data, {})
          .then(response => {
            self.request_statuses = response.data.rslt
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_pre_requests($state) {
        // this.request_items = [];
        this.request_items = JSON.parse(localStorage.getItem('buy_orders_finalize'))
      },
      infiniteHandler($state) {
        var self = this
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
          self.page += 1
          self.get_pre_requests($state)
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000)
      },
      save() {
        if (this.files.length) {
          this.upload_image(0)
          //
          // for (var i = 0; i < this.files.length; i++) {
          // }
        } else {
          bus.$emit('show_toast', [1500, this.$t('please_select_image')])
        }
      },
      select_file() {
        // if (index == 0) {
        // this.open_camera();
        // this.dialog_camera = true;
        // document.getElementById('fileUpload').click()
        // }
        // if (index == 1) {
        document.getElementById('fileUpload').click()
        // }
      },
      delete_file(index) {
        this.files.splice(index, 1)
      },
      input_file_changed() {
        console.log("input_file_changed")
        var self = this

        var reader = new FileReader()
        var f = document.getElementById('fileUpload').files
        // if (f != null) {
        reader.onloadend = function () {
          // console.log(reader.result);
          if (!reader.result.startsWith('data:image/webp')) {
            self.resizeBase64Img(reader.result, 700, 700).then(function (newImg) {
              // $("body").append(newImg[0]);
              // console.log("resized",newImg[0].src)
              var obj = {file: newImg[0].src, preview: reader.result, upload: 0}
              self.files.push(obj)
              reader = null;
              f = null;
              document.getElementById('fileUpload').files = null;
              obj = null;
            })
            // console.log(obj)
          } else {
            bus.$emit('show_toast', [1500, self.$t('fileIsNotGranted')])
          }
        };
        reader.readAsDataURL(f[0])

        // }

      },

      async resizeBase64Img(base64, minimum) {
        try {

          var canvas = document.createElement('canvas')

          var deferred = $.Deferred()
          $('<img/>').attr('src', base64).load(function () {
            var last_width = this.width
            var last_height = this.height

            if (last_width > last_height) {
              last_width = (last_width * minimum) / last_height
              last_height = minimum
            } else {
              last_height = (last_height * minimum) / last_width
              last_width = minimum
            }
            canvas.width = last_width
            canvas.height = last_height
            var context = canvas.getContext('2d')

            console.log(this.width, this.height)
            context.scale(last_width / this.width, last_height / this.height)
            context.drawImage(this, 0, 0)

            deferred.resolve($('<img/>').attr('src', canvas.toDataURL()))
          })
          return deferred.promise()
        } catch (e) {
          bus.$emit('show_toast', [3000, "error on Base64Img"])

        }
      },
      upload_image(index) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var form_data = new FormData()
        form_data.append('UserId', user_id)
        form_data.append('ProcessId', this.$route.params.rec_id)
        form_data.append('Format', 'png')
        form_data.append('ReqType', 10)
        form_data.append('DocType', 1)
        var my_file = this.files[index].file

        var file = this.dataURLtoFile(my_file, 'attach.png')
        form_data.append('Picture', file)

        this.axios.post('UploadFile', form_data, {})
          .then(response => {
            // self.send_signature(response.data.ArchiveId,response.data.ImageName);
            if (response.data.error == 0) {
              self.files[index].upload = 1
              self.files[index].ArchiveId = response.data.ArchiveId
              self.files[index].ImageName = response.data.ImageName
              // if (index < self.files.length - 1) {
              //   self.upload_image(index + 1)
              // } else {
                self.send_attach()
              // }

              // var finish_all = true;
              //   self.files.forEach(function (number) {
              //     if (number.upload != 1) {
              //       finish_all = false;
              //     }
              //   });
              // if (finish_all) {
              //   self.files[0].upload = 1;
              //
              // }
            } else {
              self.files[index].upload = 2
              bus.$emit('show_toast', [1500, response.data.msg])
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      dataURLtoFile(dataurl, filename) {
        try {

          var arr = dataurl.split(',')
          var mime = arr[0].match(/:(.*?);/)[1]
          var bstr = atob(arr[1])
          var n = bstr.length
          var u8arr = new Uint8Array(n)

          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }

          return new File([u8arr], filename, {type: mime})
        } catch (e) {
          bus.$emit('show_toast', [3000, "error on dataURLtoFile"])

        }
      },

      send_attach() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        // console.log();

        var attachment_array = []

        self.request_items.forEach(function (number) {

          var pre_obj = {
            StatusId: self.request_statuses[12],
            ImageName: self.files[0].ImageName,
            Summary: '',
            FileTypeId: 1,
            GRequestProductId: number.GoodsRequestProductId,
          }
          attachment_array.push(pre_obj)
        })

        const send_data = {
          Attachments: attachment_array,
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddGoodsRequestProductFile', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])

            if (response.data.error == 0) {
              self.$router.go(-1)
            }

          }).catch(e => {
          this.errors.push(e)
        })
      }

    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
